// src/pages/TestCropPage.tsx
import React, { useContext } from "react";
import FileUpload from "../../upload/FileUpload";
import { Context } from "../../../index"; // ← путь к твоему Context

const TestCropPage = () => {
  const { uploadStore } = useContext(Context);

  const handleUpload = async (file: File) => {
    // Загружаем на тестовый endpoint (пока не важно какой)
    const url = await uploadStore.uploadImage(file, "/upload-test");

    if (url) {
      alert(`Успех! URL: ${url}`);
    } else {
      console.error("❌ Ошибка:", uploadStore.error);
      alert(`Ошибка: ${uploadStore.error || "неизвестная"}`);
    }
  };

  return (
    <div style={{ padding: "40px" }}>
      <h2>🧪 Песочница: FileUpload + UploadStore</h2>
      <p>Выбери изображение → обрежь квадрат → загрузи.</p>

      <div style={{ marginTop: "24px", maxWidth: "300px" }}>
        <FileUpload onUpload={handleUpload}>
          <div
            style={{
              width: "120px",
              height: "120px",
              border: "2px dashed #999",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px",
              color: "#999",
            }}
          >
            📤
          </div>
        </FileUpload>

        {/* Индикация состояния */}
        {uploadStore.isUploading && <p>⏳ Загрузка...</p>}
        {uploadStore.error && (
          <p style={{ color: "red" }}>❗ {uploadStore.error}</p>
        )}
      </div>
    </div>
  );
};

export default TestCropPage;
